import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUnlinkComponent } from "./med-icon-unlink.component";

@NgModule({
  declarations: [
    MedIconUnlinkComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUnlinkComponent,
  ],
})
export class MedIconUnlinkModule { }
